import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { categories } from '@/mocks/categories';

export default function CategoryDropdown() {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const [selected, setSelected] = useState('');

  const handleSelect = (url: string) => {
    window.open(url, '_blank', 'noopener,nofollow');
    setIsOpen(false);
    setSelected('');
  };

  return (
    <section id="categories" className="w-full px-4 md:px-6 lg:px-8 py-12 md:py-16 bg-background-50">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-8">
          <h2 className="font-heading text-3xl md:text-4xl font-semibold text-foreground-950 mb-3">
            {t('categories_title')}
          </h2>
          <p className="text-foreground-600 text-base">
            {t('categories_browse')}
          </p>
        </div>

        <div className="relative max-w-lg mx-auto mb-10">
          <button
            onClick={() => setIsOpen(!isOpen)}
            className="w-full flex items-center justify-between px-5 py-3.5 bg-white border border-background-300 rounded-lg text-left hover:border-primary-400 transition-colors focus:outline-none focus:ring-2 focus:ring-primary-300"
          >
            <span className={selected ? 'text-foreground-900' : 'text-foreground-400'}>
              {selected || t('categories_select')}
            </span>
            {isOpen ? (
              <i className="ri-arrow-up-s-line w-5 h-5 flex items-center justify-center text-foreground-500" />
            ) : (
              <i className="ri-arrow-down-s-line w-5 h-5 flex items-center justify-center text-foreground-500" />
            )}
          </button>

          {isOpen && (
            <div className="absolute top-full left-0 right-0 mt-2 bg-white border border-background-200 rounded-lg shadow-xl overflow-hidden z-30 max-h-80 overflow-y-auto">
              {categories.map((cat) => (
                <button
                  key={cat.name}
                  onClick={() => handleSelect(cat.url)}
                  className="w-full flex items-center gap-3 px-5 py-3 text-left text-sm text-foreground-700 hover:bg-background-100 hover:text-primary-600 transition-colors"
                >
                  <img
                    src={cat.image}
                    alt={cat.name}
                    className="w-8 h-8 rounded object-cover flex-shrink-0"
                  />
                  <span className="flex-1">{cat.name}</span>
                  <i className="ri-external-link-line w-4 h-4 flex items-center justify-center text-foreground-400" />
                </button>
              ))}
            </div>
          )}
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-7 gap-3">
          {categories.map((cat) => (
            <a
              key={cat.name}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group flex flex-col bg-white border border-background-200/70 rounded-lg overflow-hidden hover:border-primary-300 transition-all"
            >
              <div className="aspect-[4/3] overflow-hidden bg-background-100">
                <img
                  src={cat.image}
                  alt={cat.name}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="px-3 py-2.5 flex items-center justify-between">
                <span className="text-xs font-semibold text-foreground-800 group-hover:text-primary-600 transition-colors truncate">
                  {cat.name}
                </span>
                <i className="ri-arrow-right-up-line w-3.5 h-3.5 flex items-center justify-center text-foreground-400 flex-shrink-0 ml-1" />
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}